import {Component, Prop} from "vue-property-decorator";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal.vue";
import Modal from "@/assets/common/Modal/Modal.vue";

@Component({
    components: {
        Modal
    }
})
export default class FertilizerSelectModal extends ItemSelectModal {
    @Prop({default: () => "肥料"})
    itemKindName!: string

    @Prop({default: () => "/fertilizers/fertilizers_from_master"})
    apiPath!: string;

    @Prop({default: () => true})
    multiple!: boolean

    @Prop({default: () => true})
    editable!: boolean

    // バリデーションチェックパラメータのオーバーライド
    validateParam = { nameLength: 100 }
}
